import { dataFor } from '../data';

export interface MedicaidCarrier {
  internalName: string;
  displayName: string;
}

export function useMedicaidCarriers(state?: string): {
  items: MedicaidCarrier[];
  isLoading: boolean;
} {
  const byState = dataFor('medicaidCarriersByState');
  const carriers = state ? byState[state] : undefined;
  if (!carriers) {
    return { items: [], isLoading: false };
  }
  const items = Object.entries(carriers).map(([internalName, displayName]) => ({
    internalName,
    displayName,
  }));
  return { items, isLoading: false };
}
